import type { TabProps, TabsProps } from "@components/contracts/Tabs.types";
import type React from "react";
import { Tabs as RsTabs } from "rsuite";

import "./Tabs.component.scss";

export const RsuiteTabs: React.FC<TabsProps> = ({ children, ...props }) => (
  <RsTabs {...props} appearance="subtle">
    {children}
  </RsTabs>
);

export const RsuiteTab: React.FC<TabProps> = ({ children, ...props }) => (
  <RsTabs.Tab {...props}>{children}</RsTabs.Tab>
);
